/// region Catalog Item Workspace Relationships ( Product <-> Colorway,  Style <-> Colorway, etc)
import {action, computed, computedFn, observable, observer, pluralize, React, useAsObservableSource, useLocalStore, utils} from '@api'
import {MenuDivider, MenuItem} from '@blueprintjs/core'
import {BuilderCardLoader, CatalogItemPreviewMenuItem, ContextMenuItem, ContextMenuItemProps, openInNewTab, useBuilderCardStore, useVipLocalStore, VipLocalStore} from '@modules'
import {ICatalogFieldConfig, LibraryItemConfigWrapper, nav, StoresInstance, useCatalog, Workspace, WorkspaceConfig} from '@stores'
import {icons} from '@stores/ui'
import {Fragment, useContext} from 'react'
import * as css from './CatalogItemRelationshipsMenuItems.css'

class WorkspaceRelationshipMenuItemsStore extends VipLocalStore {
  constructor(stores: StoresInstance,public workspace: Workspace) {
    super(stores)
  }

  @computed get referToUs() { return this.catalog.relationships.otherWorkspaceFieldsThatReferTo(this.workspace.config)}

  @computed get usedByUs() { return this.catalog.relationships.librariesOfWorkspace(this.workspace.config).filter(l => /*!l.config.where && */ l.workspaceId != this.workspace._id && l.index != this.workspace.catalog?.index) }

}

export const WorkspaceRelationshipMenuItems = observer<{ workspace: Workspace } & ContextMenuItemProps>(function WorkspaceRelationshipMenuItems({workspace, ...props}) {
  const store = useVipLocalStore((ws) => new WorkspaceRelationshipMenuItemsStore(ws, workspace)),
    {workspaces, referToUs, usedByUs, stores: {sidebar}} = store
  return (<Fragment>
    {false && !_.isEmpty(referToUs) && <ContextMenuItem {...props} icon={icons.relationships} text='Referenced By...'>
      {false && <MenuDivider title={`Used By (${_.size(referToUs)})`}
        // disabled={_.isEmpty(referToUs)}
        // icon={icons.usedBy}
	  />}
      {_.entries(referToUs).map(([wsId, fields], i) => {
        const ws = workspaces.wrapperById[wsId],
          url = null /* nav.urlFor_string(
            {
              workspace: ws.config,
              queryParams: sidebar.queryParamsFor({left: {open: true, tab: 0, path: [{libraryId: `${workspace._id}|${workspace.catalog.index}|${workspace.config.title}`, sidebarContext: 'libraries'}]}})
            }
          )*/

        return (
          <Fragment key={i}>
            {fields.map((f, j) => (
              <ContextMenuItem
                key={f.field}
                data-workspace={ws.id}
                data-field={f.field}
                text={`${ws.config.itemName}`} // -> ${ws.catalog.labelForField(f)}
                href={url}
                onClick={(e) => {
                  utils.eatMouseEvent(e)
                  openInNewTab(url)
                }}
              />))}
          </Fragment>)
      })}
      {false && !_.isEmpty(usedByUs) && <Fragment>
        {false && <MenuDivider title={`Uses ( ${usedByUs.length})`}/>}
		  <MenuDivider/>
        {usedByUs.map((l, i) => <ContextMenuItem key={l.id} text={`${l.workspace?.itemName ?? l.id} -> ${l.label}`} onClick={() => sidebar.left.navigateToLibrary({libraryId: l.id}, true)}/>)}
	  </Fragment>}
	</ContextMenuItem>}
  </Fragment>)
})

export const useNewWorkspaceRelationshipStore = (field?: ICatalogFieldConfig) => {
  const store = useBuilderCardStore()
  if (!store) return null

  const {catalog} = store,
    index = store.index ?? catalog?.index,
    id = store.id ?? catalog.idFor(store?.data),
    obsProps = useAsObservableSource({id, data: store.data, index, field: field}),
    r = useVipLocalStore((ws) => new WorkspaceRelationshipStore(ws, obsProps))

  return r
}
export const BuilderCardRelationshipsContextMenuItem = observer<ContextMenuItemProps & { wrapWithMenuItem?: boolean }>(function BuilderCardRelationshipsContextMenuItem(props) {
  const {id, index, data} = useBuilderCardStore()

  return <CatalogItemRelationshipsContextMenuItem {...props} id={id} index={index} data={data}/>
})

export const CatalogItemRelationshipsContextMenuItem = observer<{ id?: string, data?: any, index?: string, wrapWithMenuItem?: boolean, field?: ICatalogFieldConfig } & ContextMenuItemProps>(
  function CatalogItemRelationshipsContextMenuItem(props) {
  const catalog = useCatalog(),
    index = props.index ?? catalog.index,
    //store = useLocalStore(() => new WorkspaceRelationshipStore(obsProps, catalog)),
    store = useNewWorkspaceRelationshipStore(props.field)

  if (!store) return null

  const {workspaces, otherWorkspaceFieldsThatReferToUs, workspaceLibraries, info: {id}} = store

  // DEBUG && console.log({store, otherWorkspaceFieldsThatReferToUs, workspaceLibraries})
  if (!id || (_.isEmpty(otherWorkspaceFieldsThatReferToUs) && _.isEmpty(workspaceLibraries))) {
    DEBUG && console.debug(`No relationships found for `, {index, id})
    return null
  }

  const usedBy = _.keys(otherWorkspaceFieldsThatReferToUs),
    totalInUse = _.sum(workspaceLibraries.map(l => {
      const catalogFields = catalog.relationships.fieldsRelatedToLibraryForWorkspace(store.workspace, l.config.name)
      const values = _.flatMap(store.valuesForFields(catalogFields).map(s => s.value).filter(_.identity))
      return values.length
    }))

  const contents = <Fragment>
    {totalInUse > 0 &&
	 <ContextMenuItem
		 text={`References (${totalInUse})`} // ${_.sum(workspaceLibraries.map(l => )}(${workspaceLibraries.length})`}
		 icon={icons.refersTo}>
       {workspaceLibraries.map(l => <BuilderCardAssociatedLibraryContextMenu library={l} key={l.config.name}/>)}
	 </ContextMenuItem>}
    {!_.isEmpty(usedBy) && (
      <ContextMenuItem
        text={`Referenced By (${_.sum(usedBy.map(id => store.data[workspaces.byId[id]?.catalog?.index]?.length ?? 0))})`} //(${usedBy.length})*/
        icon={icons.usedBy}>
        {usedBy.map(id => <WorkspaceRelationshipContextMenuItems workspace={workspaces.byId[id]} fields={otherWorkspaceFieldsThatReferToUs[id]} key={id}/>)}
      </ContextMenuItem>)}
  </Fragment>

  return <WorkspaceRelationshipStoreContext.Provider value={store}>
    {props.wrapWithMenuItem ?
     <ContextMenuItem {..._.omit(props, ['wrapWithMenuItem', 'id', 'data', 'index', 'field'])} icon={icons.relationships} text={'Relationships'} data-type='CatalogItemRelationshipsContextMenuItem'>
       {contents}
     </ContextMenuItem> : contents}
  </WorkspaceRelationshipStoreContext.Provider>
})

const BuilderCardAssociatedLibraryContextMenu = observer<{ library: LibraryItemConfigWrapper }>(function BuilderCardAssociatedLibraryContextMenu({library}) {
  const store = useWorkspaceRelationshipStore(),
    {strings, workspace, catalog} = store,
    catalogFields = catalog.relationships.fieldsRelatedToLibraryForWorkspace(workspace, library.config.name)

  // console.log(library.title, toJS({catalogFields, data}, {recurseEverything: true}))

  if (_.isEmpty(catalogFields)) return null

  return <Fragment>
    {store.valuesForFields(catalogFields).map(({field: f, value: v}) => {
      const label = catalog.labelForField(f)

      // console.log({f, v})
      if (!v) {
        return null
        // return <Fragment key={f.field}>
        //   <MenuDivider title={label}/>
        //   <ContextMenuItem key={f.field} text={strings.unassigned}>
        //   </ContextMenuItem>
        // </Fragment>
      } else {
        if (_.isArray(v)) {
          return (
            <Fragment key={f.field}>
              <MenuDivider title={pluralize(label)}/>
              {v.map((item, i) => <BuilderCardAssociatedLibraryContextMenuItem noTitle data={item} key={i} field={f} library={library}/>)}
            </Fragment>
          )
        } else {
          return <BuilderCardAssociatedLibraryContextMenuItem key={f.field} data={v} field={f} library={library}/>
        }
      }
    })}
  </Fragment>
})

const BuilderCardAssociatedLibraryContextMenuItem = observer<{ noTitle?: boolean, data: any, library?: LibraryItemConfigWrapper, field: ICatalogFieldConfig }>(function BuilderCardAssociatedLibraryContextMenu({noTitle, library, field, data}) {
  const store = useWorkspaceRelationshipStore(),
    {catalog} = store,
    itemId = catalog.idFor(data),
    label = catalog.labelForField(field),
    {dataMap} = library,
    href = nav.urlForWorkspace({workspace: library.workspace, itemId, queryParams: {...catalog.queryParamsFor({detailLoc: 'sidebar'})}}, true)

  return (
    <Fragment>
      {!noTitle && <MenuDivider title={label}/>}
      <CatalogItemPreviewMenuItem key={field.field}
                                  data={data}
                                  index={library.config.index}
                                  dataMap={dataMap}
                                  library={library}
                                  href={href}
                                  workspace={store.workspace}
                                  popoverProps={{className: css.catalogItemPreviewPopover, ...MenuItem.defaultProps.popoverProps}}
                                  noSubmenuPadding
                                  field={field}
                                  onClick={(e) => {
                                    utils.eatMouseEvent(e)
                                    library.workspace && openInNewTab(href)
                                  }}>
        {library.workspace && <Fragment>
          {/*<OpenInWorkspaceMenuItem workspace={library.workspace} id={itemId}/>
	        <OpenInC8MenuItem id={itemId}/>
            <MenuDivider />*/}
			<BuilderCardLoader
				className={css.builderCard}
				hideButtons
				isPopover
				levelOfDetail={1}
				field={{esIndex: library.workspace.catalog.index}}
				nested={{data}}
				id={itemId}/>
          {/*<OpenInWorkspaceMenuItem noTitle flatten workspace={library.workspace} id={itemId}/>*/}
		</Fragment>}
      </CatalogItemPreviewMenuItem>
    </Fragment>
  )
})

const WorkspaceRelationshipContextMenuItems = observer(function WorkspaceRelationshipContextMenuItems({workspace, fields, hideIfEmpty}: WorkspaceRelationshipProps) {
  const {itemName, catalog: {index}} = workspace,
    {data, loading, catalog} = useWorkspaceRelationshipStore(),
    dataMap = catalog.dataMapForWorkspace(workspace),
    results = data[index] ?? []

  //{fields.map(f => <ContextMenuItem key={f.field}
  //                                           text={`Go to ${workspace.title} Workspace  (${catalog.labelForField(f)})`}
  //                                           icon={icons.workspace}
  //                                           onClick={() => openInNewTab(nav.workspaceUrlFor(workspace._id, { /* Todo - filter on field = this value */ }))}/>)}

  // if (false) {
  //   return (
  //     <Fragment>
  //       <ContextMenuItem className={css.dividerForWorkspace}
  //                        text={<div className={css.titleAndCount}><span className={css.title}>{pluralize(workspace.itemName)}</span><span className={css.count}>{!loading ? ` (${results.length})` : ''}</span></div>}
  //                        icon={icons.workspace}
  //                        onClick={() => openInNewTab(nav.workspaceUrlFor(workspace._id, { /* Todo - filter on field = this value */}))}
  //       >
  //
  //       </ContextMenuItem>
  //
  //       {fields.map(f =>
  //         <Fragment key={f.field}>
  //           {fields.length > 1 && <ContextMenuItem text={`${pluralize(itemName)} + ${catalog.labelForField(f)}`}/>}
  //
  //         </Fragment>
  //       )}
  //     </Fragment>
  //   )
  // }

  //<-> ${fields.map(f => catalog.labelForField(f)).join(', ')}`}

  if (hideIfEmpty && _.isEmpty(results)) return null

  return <Fragment>
    <MenuDivider title={workspace.title}/>
    {_.isEmpty(results) ? <ContextMenuItem className={css.noResults} text='No Results'/>
                        : (results ?? []).map(({_source: data}) => {
        const itemId = catalog.idFor(data)

        return <CatalogItemPreviewMenuItem key={itemId}
                                           workspace={workspace}
                                           data={data}
                                           popoverProps={{className: css.catalogItemPreviewPopover}}
                                           index={index}
                                           dataMap={dataMap}
                                           noSubmenuPadding
                                           onClick={() => workspace && openInNewTab(nav.urlForWorkspace({workspace, itemId, queryParams: {...catalog.queryParamsFor({detailLoc: 'sidebar'})}}, true))}>
          {/*<FullSizePreviewMenuItem>*/}
          <BuilderCardLoader
            className={css.builderCard}
            hideButtons
            isPopover
            levelOfDetail={1}
            field={{esIndex: index}}
            nested={{data: data}}
            id={itemId}/>
          {/*</FullSizePreviewMenuItem>*/}
          {/*<OpenInWorkspaceMenuItem flatten noTitle workspace={workspace} id={itemId}/>*/}
        </CatalogItemPreviewMenuItem>
      })}
  </Fragment>
})

type WorkspaceRelationshipProps = { hideIfEmpty?: boolean, workspace: WorkspaceConfig, fields: Array<ICatalogFieldConfig> }

export class WorkspaceRelationshipStore extends VipLocalStore {
  constructor(stores: StoresInstance,public info: { id: string, index: string, data?: any, field?: ICatalogFieldConfig }) {
    super(stores)
    this.catalog.componentStores.contextWorkspaceRelationship = this
    this.runQuery()
  }

  valuesForFields = computedFn((fields: Array<ICatalogFieldConfig>) => {
    // This is insufficient, we will not have the data on hand in the builder card object we were handed unless view options happened to include it
    const {workspace, catalog, es} = this
    return fields.map(f => {
      // This is insufficient, we will not have the data on hand in the builder card object we were handed unless view options happened to include it
      const fieldPath = catalog.esFieldFor(f)
      let v = (this.data[workspace._id] ?? []).find(v => es.readField(v._source, fieldPath)?.val)

      if (!v) {
        v = es.readField(this.info.data, catalog.esFieldFor(f))?.val
      }

      return {field: f, value: v}
    })
  })

  @computed get workspace() {
    return this.workspaces.byIndexScalar[this.info.index]
  }

  @computed get workspaceLibraries() {
    return this.catalog.relationships.librariesOfWorkspace(this.workspace).filter(l => !l.config.where)
  }

  @computed get otherWorkspaceFieldsThatReferToUs() {
    return this.catalog.relationships.otherWorkspaceFieldsThatReferTo(this.workspace)
  }

  @computed get msearchBody() {
    const {workspaces, catalog: {esFieldFor, idFor}, info: {data}, otherWorkspaceFieldsThatReferToUs, workspaceLibraries} = this,
      id = idFor(data)

    return [
      ..._.keys(otherWorkspaceFieldsThatReferToUs).map((id) => workspaces.byId[id]).reduce(
        (acc, workspace) => {
          const otherFields = otherWorkspaceFieldsThatReferToUs[workspace._id]

          // console.debug(`Workspace ${workspace._id} refers to our workspace catalog item via fields: ${otherFields.map(f => f.field).join(', ')}`)
          return (
            [
              ...acc,
              {index: workspace.catalog.index},
              {
                _source: [],
                query: {
                  bool: {
                    minimum_should_match: 1,
                    should: otherFields.map(f => {
                      /*
                        For example we're right clicked on a specific colorway in the colorways workspace and we want to see contextually which MPVs include THIS colorway

                        We don't want to match on name, we want to match on ID

                        But if we're right clicked on a spec group in the MPV workspace we want to match against the IDs of the contents of our group (not the name which is what we're grouping on)
                       */
                      //const field = catalog.esFieldFor(f, true)
                      //   value = _.get(data, f.group?.field ?? (_.isObject(f.filter) && f.filter?.subField))

                      const id = idFor(data)

                      return {term: {[`${esFieldFor(f)}.id`]: id}}
                    })
                  }
                }
              }
            ])
        }, []),
      ...workspaceLibraries.filter(l => l.catalogField).reduce((acc, l) => {
        if (!id) {
          return acc
        }

        acc.push(
          {index: this.workspace.catalog.index},
          {
            _source: [l.catalogField.field],
            query: {
              bool: {
                filter: {
                  term: {
                    '_id': id
                  }
                }
              }
            }
          })
        return acc
      }, [])
    ]
  }

  @observable.ref data: { [esIndex: string]: Array<{ _id?: string, _source: any }> } = {}
  @observable loading = true
  @action runQuery = async () => {
    try {
      const {msearchBody, es} = this

      if (!_.isEmpty(msearchBody)) {
        const {info: {id, index}} = this
        const {responses} = await es.msearch({
          meta: `Query for relationships to ${id} - ${index}`,
          body: msearchBody
        }, {log: {query: false, result: false}})
        this.data = _.groupBy(_.flatMap((responses ?? []).map(r => r.hits.hits)), h => h._index)
      }
    } catch (err) {
      console.error(err)
    } finally {
      this.loading = false
    }
  }
}

export const WorkspaceRelationshipStoreContext = React.createContext<WorkspaceRelationshipStore>(undefined)
export const useWorkspaceRelationshipStore = () => useContext(WorkspaceRelationshipStoreContext)

/// endregion




// WEBPACK FOOTER //
// ./src/modules/contextMenus/menus/internal/catalogItemRelationships/CatalogItemRelationshipsMenuItems.tsx